import {Injectable} from '@angular/core';
import {
    CountySelection,
    CountySpendingReportClient,
    CountySpendingReportParameter,
    PagedListOfCountySpendingReportPreview
} from './api.client';
import {Observable} from 'rxjs';
import {share} from 'rxjs/operators';

@Injectable()
export class CountySpendingReportService {

    constructor(private _countySpendingReportClient: CountySpendingReportClient){
    }

    getCounties(): Observable<CountySelection[]> {
        return this._countySpendingReportClient.getCounties();
    }

    previewCountySpendingReport(
        parameters: CountySpendingReportParameter,
        sortName: string,
        descending: boolean,
        limit: number,
        offset: number): Observable<PagedListOfCountySpendingReportPreview> {
        return this._countySpendingReportClient.previewCountySpendingReport(
            parameters,
            sortName,
            null,
            descending,
            limit || 10,
            offset || 0)
            .pipe(share());
    }
}
